export default __webpack_public_path__ + "static/the-differance-is-clear-es_converted-2c92efaa513a25a3034f32d35694ac61.mp4";